import { render } from "./EnhancedBarChart.vue?vue&type=template&id=53789584&scoped=true"
import script from "./EnhancedBarChart.vue?vue&type=script&lang=js"
export * from "./EnhancedBarChart.vue?vue&type=script&lang=js"

import "./EnhancedBarChart.vue?vue&type=style&index=0&id=53789584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53789584"]])

export default __exports__